import { GET_SEARCH_DESCRIPTION } from "../../requests"
import { SET_SEARCH_EDGE, INIT_SEARCH_VALUE_CACHE_AND_STALES } from './searchReducer'

export const setResults = (results, category, searchValue) => ({
  type: '@@SEARCH_SET_RESULTS',
  results,
  category,
  searchValue,
})

export const selectRow = (category, recordId) => ({
  type: '@@SEARCH_SELECT_ROW',
  category,
  recordId,
})

export const setResultsMode = (mode) => ({
  type: '@@SEARCH_SET_RESULTS_MODE',
  mode,
})

export const toggleSearching = (searching) => ({
  type: '@@SEARCH_TOGGLE_SEARCHING',
  searching,
})

export const setSearchError = (searchError, category) => ({
  type: '@@SEARCH_SET_SEARCH_ERROR',
  searchError,
  category,
})

export const clearSearchError = (category) => ({
  type: '@@SEARCH_CLEAR_SEARCH_ERROR',
  category,
})

export const getSearchDescription = (category) => (dispatch) => {
  return new Promise((resolve) => {
    GET_SEARCH_DESCRIPTION(category, (description) => {
      dispatch({
        type: '@@SEARCH_SET_DESCRIPTION',
        category,
        description,
      })
      resolve(description)
    })
  })
}

export const setSort =
  ({ category, sortBy, sortByDirection }) =>
  (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        type: '@@SEARCH_SET_SORT',
        category,
        sortBy,
        sortByDirection,
      })
      resolve()
    })
  }

export const setSearchEdge =
  ({ category, pageNum, pageSize, totalRows }) =>
  (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SET_SEARCH_EDGE,
        category,
        pageNum,
        pageSize,
        totalRows,
      })
      resolve()
    })
  }

export const setActiveCategory = (category) => (dispatch) => {
  dispatch({
    type: '@@SEARCH_SET_ACTIVE_CATEGORY',
    category,
  })
  dispatch({
    type: 'SET_CURRENT_CATEGORY',
    category,
  })
}

export const invalidateAllCategoryCaches = () => (dispatch) => {
  dispatch({
    type: '@@SEARCH_INVALIDATE_CACHE',
  })
}

export const initializeSearchCacheAndStales = () => (dispatch) => {
  dispatch({ type: INIT_SEARCH_VALUE_CACHE_AND_STALES })
}